import { createAsyncThunk } from '@reduxjs/toolkit';
import { storeResources } from 'store/resources';
import { getGoogleSettings } from 'services/auth';
import { IGoogleSettings } from 'services/auth/types';

export const ThunkGetGoogleSettings = createAsyncThunk<IGoogleSettings>(
  `${storeResources.AUTH}/getGoogleSettings`,
  () => getGoogleSettings().then(r => r.data),
);
